import React from "react"

// components
import { Space, Typography, Avatar, Row, Col, Button, Tag } from "antd"
import { MinusOutlined } from "@ant-design/icons"

// styling
import styled from "@emotion/styled"

// store
import { useTranslation } from "react-i18next"

// utils
import { formatAsCurrency } from "utils/currency"
import { calculateChoicesCosts } from "utils/menu"

const Component = styled.div`
  width: 100%;

  .ant-btn {
    display: none;
  }

  @media (max-width: 820px) {
    .ant-btn {
      display: block;
    }
  }

  &:hover {
    .ant-btn {
      display: block;
    }
  }
`

const MenuItem = ({ list, titles, onRemove = () => null }) => {
  const { t } = useTranslation()
  if (titles)
    return (
      <Component style={{ borderBottom: "1px solid black" }}>
        <Row
          justify="space-between"
          style={{ width: "100%", padding: "4px 16px" }}
        >
          <Col>
            <Space>
              <Typography.Text
                style={{
                  width: 16,
                  display: "inline-block",
                }}
              />
              <Typography.Text
                style={{
                  width: 4,
                  display: "inline-block",
                }}
              />
              <Typography.Text strong italic>
                {t("name")}
              </Typography.Text>
              <Typography.Text italic>({t("price")})</Typography.Text>
            </Space>
          </Col>

          <Col>
            <Space>
              <Typography.Text strong>Total</Typography.Text>
              <Typography.Text italic>({t("incl_mwst")})</Typography.Text>
            </Space>
          </Col>
        </Row>
      </Component>
    )

  const item = list[0]

  return (
    <Component>
      <Row justify="space-between" style={{ width: "100%" }}>
        <Col span={20}>
          <Space direction="vertical">
            <Space style={{ alignItems: "flex-start" }}>
              <Typography.Text
                style={{
                  width: 16,
                  display: "inline-block",
                }}
              >
                {list.length}x
              </Typography.Text>
              <Typography.Text
                style={{
                  width: 4,
                  display: "inline-block",
                }}
              >
                |
              </Typography.Text>
              <Typography.Text strong italic>
                <Tag>{item.id}</Tag>
                {item.name}
              </Typography.Text>
              {item.scharf === 2 ? (
                <span style={{ whiteSpace: "nowrap" }}>
                  <Avatar
                    src="icons/chili.png"
                    size={16}
                    alt="icon-chili"
                    style={{ marginRight: "-10px" }}
                  />
                  <Avatar src="icons/chili.png" size={16} alt="icon-chili" />
                </span>
              ) : item.scharf === 1 ? (
                <Avatar src="icons/chili.png" size={16} alt="icon-chili" />
              ) : null}
              {item.vegetarisch ? (
                <Avatar src="icons/leaf.png" size={16} alt="icon-leaf" />
              ) : null}
              <Typography.Text italic style={{ whiteSpace: "nowrap" }}>
                ({formatAsCurrency(item.preis)})
              </Typography.Text>
            </Space>
            {item.settings && item.choices && (
              <Space wrap>
                {Object.entries(item.choices).map(([key, value]) => {
                  const setting = item.settings.find((set) => set.key === key)
                  if (setting) {
                    switch (setting.type) {
                      case "checkbox":
                        return value.map((val) => {
                          const option = setting.options.find(
                            (opt) => opt.value === val
                          )
                          if (option) {
                            return (
                              <Typography.Text
                                key={key + val}
                                italic
                                type="secondary"
                              >{`${setting.label}: ${
                                option.label
                              } (${formatAsCurrency(
                                option.preis
                              )})`}</Typography.Text>
                            )
                          }
                          return null
                        })

                      case "radio":
                        const option = setting.options.find(
                          (opt) => opt.value === value
                        )
                        if (option) {
                          return (
                            <Typography.Text key={key} italic type="secondary">
                              {`${setting.label}: ${option.label} ${
                                option.preis
                                  ? `(${formatAsCurrency(option.preis)})`
                                  : ""
                              }`}
                            </Typography.Text>
                          )
                        }
                      default:
                        return null
                    }
                  }
                  return null
                })}
              </Space>
            )}
            <Button
              style={{ marginBottom: 8 }}
              icon={<MinusOutlined />}
              type="dashed"
              size="small"
              onClick={() => onRemove(item.id)}
            >
              {t("remove")}
            </Button>
          </Space>
        </Col>

        <Col span={4} style={{ textAlign: "right" }}>
          <Typography.Text strong>
            {formatAsCurrency(
              list.length *
                (item.preis +
                  calculateChoicesCosts(item.choices, item.settings))
            )}
          </Typography.Text>
        </Col>
      </Row>
    </Component>
  )
}

export default MenuItem
